// Generated by tools/export_web_contract.py from contract/constants.json -- do not edit.

// The wire values come from contract/constants.json; ./tuning.js holds what is
// the device's own (scoring cadence, chirp, capture-gap detection).
export * from "./tuning.js";

export const ALLOWED_BROWSER_CLOSE_REASONS = ["clean_close", "client_stop", "going_away", "navigation", "normal", "page_unload", "probe_stop", "timeout", "visibility_hidden"];
export const AUDIO_NOT_ACCEPTED = "audio_not_accepted";
export const CHIRP_N_TONES = 8;
export const CLAIM_DELTA_PROTOCOL_VERSION = "claim-delta/v1";
export const CLAIM_DOMAIN = "meetfolks/claim-bundle/v1\u0000";
export const CLAIM_FLOOR = 0.25;
export const CLAIM_MAX_AGE_SEC = 86400;
export const CLAIM_MAX_FUTURE_SKEW_SEC = 300;
export const CONFIDENCE_BAND = 0.05;
export const DEVICE_TOKEN_ROTATE_AFTER_DAYS = 30;
export const DEVICE_TOKEN_TTL_DAYS = 90;
export const EMBED_DIM = 192;
export const ENROLL_TAKES = 3;
export const ENROLL_TAKE_SEC = 7.0;
export const ENVELOPE_FRAME_SEC = 0.025;
export const ENVELOPE_HOP_SEC = 0.01;
export const ENVELOPE_WIRE_RATE_HZ = 50.0;
export const FREE_GRANT_CREDITS = 120;
export const HOP_SEC = 1.0;
export const JOIN_CODE_ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
export const JOIN_CODE_LENGTH = 5;
export const JOIN_CODE_TTL_SEC = 14400;
export const MAGIC_LINK_TTL_SEC = 600;
export const MAX_ENVELOPE_FRAMES = 720000;
export const MAX_INTERVALS = 20000;
export const MAX_SAMPLES_PER_FRAME = 1600;
export const MERGE_FRAME_SEC = 1.0;
export const MIN_SPEECH_SEC = 3.0;
export const NATIVE_AUTH_CODE_TTL_SEC = 300;
export const NONCE_BYTES = 16;
export const PROTOCOL_VERSION = "1.0";
export const SAMPLE_RATE = 16000;
export const SINGLE_DEVICE_THRESHOLD = 0.328;
export const STREAM_ARCHIVE_REPLAY_CONFLICT_REASON = "archive_replay_conflict";
export const STREAM_RESUMABLE_CLOSE_REASONS = ["frame_processing_timeout", "missing_tail", "stream_byte_limit", "stream_duration_limit", "stream_replay_limit"];
export const TICKET_TTL_SECONDS = 120;
export const TICKET_VERSION = "m0";
export const TRIM_TOP_DB = 30;
export const VAD_BRIDGE_GAP_SEC = 0.3;
export const VAD_FRAME_SEC = 0.025;
export const VAD_GLOBAL_FLOOR_DB = 55.0;
export const VAD_HOP_SEC = 0.01;
export const VAD_LOCAL_TOP_DB = 30.0;
export const VAD_LOCAL_WINDOW_SEC = 2.0;
export const VAD_MIN_REGION_SEC = 0.5;
export const WHOLE_CLIP_THRESHOLD = 0.508;
export const WINDOW_SEC = 2.0;
export const WIRE_DB_FLOOR = -127.5;
export const WIRE_DB_STEP = 0.5;
